const defaultWeekdayOptions = {
    default: {
        // Wednesday
        weekday: "long",
    },
};
export { defaultWeekdayOptions };
